import { render, staticRenderFns } from "./page.vue?vue&type=template&id=da1417a4&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1417a4')) {
      api.createRecord('da1417a4', component.options)
    } else {
      api.reload('da1417a4', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=da1417a4&", function () {
      api.rerender('da1417a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/page.vue"
export default component.exports